import { render } from "./SendSmartContract.vue?vue&type=template&id=2d5683c6&ts=true"
import script from "./SendSmartContract.vue?vue&type=script&lang=ts"
export * from "./SendSmartContract.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__